import { fetchGet, fetchPost } from '@/utils/axiosfunc'

const api = {
  mobilebus: '/mobilebus',
  api: '/api',
  client: '/client',
  service: '/service',
  backend: '/backend',
  user: '/user',
  pay: '/pay',
  wxJsBeanUrl: '/getWxJsBean.do',
  wxPayPrepayidUrl: '/getWXPayPrepayid.do',
  updateWxPayStatusUrl: '/updateWXPayStatus.do',
  carouselUrl: '/carouselImg.do',
  menuUrl: '/menu.do',
  mpUrl: '/mp.do',
  busCountUrl: '/count.do',
  busDetailUrl: '/single.do',
  startBusinessUrl: '/start.do',
  nextBusinessUrl: '/next.do',
  scheduleListUrl: '/query.do',
  getAllContractUrl: '/getAllContract.do',
  getBizTokenUrl: '/getBizToken.do',
  getEyeInfoUrl: '/getEyeInfo.do'
}

export default api

export function getWxJsBeanReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + '/' + parameter.token + api.wxJsBeanUrl, parameter)
}

export function getWxPayPrepayid (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.pay + api.wxPayPrepayidUrl, parameter)
}

export function updateWxPayStatusReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.pay + api.updateWxPayStatusUrl, parameter)
}

export function getCarouseReq (parameter) {
  return fetchGet(api.mobilebus + api.client + api.api + api.carouselUrl, parameter)
}

export function getMenuUrlReq (parameter) {
  return fetchGet(api.mobilebus + api.client + api.api + api.menuUrl, parameter)
}

export function getMpReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.mpUrl, parameter)
}

export function getBusCountReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.busCountUrl, parameter)
}

export function getBusDetailReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.busDetailUrl, parameter)
}

export function startBusinessReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.startBusinessUrl, parameter)
}

export function nextBusinessReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.nextBusinessUrl, parameter)
}

export function getScheduleListReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.scheduleListUrl, parameter)
}

export function getAllContractReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + api.getAllContractUrl, parameter)
}

export function getBizTokenReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + '/' + parameter.token + api.getBizTokenUrl, parameter)
}

export function getEyeInfoReq (parameter) {
  return fetchPost(api.mobilebus + api.client + api.api + '/' + parameter.token + api.getEyeInfoUrl, parameter)
}
